export function getLocaleFromUrl() {
    return window.location.pathname.split('/').filter(i => !!i)[0];
}
